export function AuthScreenLoading() {
  return (
    <main className="h-screen w-full bg-cover flex justify-end max-lg:justify-center max-lg:items-center">
      <div className="w-[594px] relative flex flex-col h-screen py-10 px-10 max-[400px]:h-screen max-[400px]:pt-12 max-[400px]:rounded-none max-lg:rounded-[20px] max-lg:w-[400px] max-lg:px-12 max-lg:py-12 overflow-auto">
        <div className="w-8/12 h-6 bg-white/20 rounded-lg animate-pulse" />
        <div className="pt-6 text-white text-xl max-lg:pt-4">
          <div className="w-6/12 h-6 bg-white/20 rounded-lg animate-pulse" />
        </div>
        
        <div className="flex flex-col mb-4 space-y-6 mt-12 animate-pulse">
          <div className="w-full h-9 bg-white/20 rounded-lg" />
          <div className="w-full h-9 bg-white/20 rounded-lg" />
        </div>
        
        <div className="flex items-center justify-between mb-4 mt-8 animate-pulse">
          <div className="w-32 h-9 bg-white/20 rounded-lg" />
          <div className="w-32 h-9 bg-white/20 rounded-lg" />
        </div>
        
        <div className="flex flex-col mb-4 space-y-4 mt-12 animate-pulse">
          <div className="w-10/12 h-6 bg-white/20 rounded-lg" />
          <div className="w-8/12 h-6 bg-white/20 rounded-lg" />
        </div>
      </div>
    </main>
  );
}
